import React, { SVGProps } from 'react';

const SvgCustomDashboard = (props: SVGProps<SVGSVGElement>) => (
    <svg 
        xmlSpace='preserve'
         width="1em" height="1em" viewBox="0 0 24 24"
        className='svg-icon' 
        fill='none'
        {...props}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M15.25 2.96973H8.75C5.43629 2.96973 2.75 5.65602 2.75 8.96973V15.4697C2.75 18.7834 5.43629 21.4697 8.75 21.4697H15.25C18.5637 21.4697 21.25 18.7834 21.25 15.4697V8.96973C21.25 5.65602 18.5637 2.96973 15.25 2.96973Z" stroke="#4B4B4B" stroke-width="1.5"/>
        <path d="M7 15.2197L9.45 11.9597C9.60003 11.759 9.81998 11.6219 10.0663 11.5756C10.3126 11.5293 10.5673 11.5772 10.78 11.7097L13.17 13.2197C13.3909 13.3604 13.6581 13.4088 13.9142 13.3546C14.1704 13.3003 14.3951 13.1478 14.54 12.9297L17 9.21973" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

);

export default SvgCustomDashboard;
